"use client";

import {
  AlertsSectionProps,
  AppointmentSectionProps,
  AppSectionProps,
  BlogsSectionProps,
  ChooseUsSectionProps,
  CommentsSectionProps,
  DoctorsSectionProps,
  FaqSectionProps,
  FeaturesSectionProps,
  HeadlineSectionProps,
  HealthSectionProps,
  HelpSectionProps,
  InfoSectionProps,
  InsurancesSectionProps,
  ListSectionProps,
  MissionSectionProps,
  NewsletterSectionProps,
  OfferSectionProps,
  OurServicesSectionProps,
  PackagesSectionProps,
  ServiceSliderSectionProps,
  ShippingSectionProps,
  StatisticsSectionProps,
  SupportSectionProps,
  TechnologySectionProps,
  TestSectionProps,
  VideoSectionProps,
  WhySectionProps,
  WorkSectionProps,
  YogaSectionProps,
} from "@/Templates/SectionsProps";
import HomeEightBlogSectionGenerated, {
  HomeEightBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeEightBlogSection.generated";
import HomeEightBookSectionGenerated, {
  HomeEightBookSectionGeneratedProps,
} from "../Sections/_generated/HomeEightBookSection.generated";
import HomeEightCompanySectionGenerated, {
  HomeEightCompanySectionGeneratedProps,
} from "../Sections/_generated/HomeEightCompanySection.generated";
import HomeEightFaqSectionGenerated, {
  HomeEightFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeEightFaqSection.generated";
import HomeEightServiceSectionGenerated, {
  HomeEightServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeEightServiceSection.generated";
import HomeEightServiceSliderGenerated, {
  HomeEightServiceSliderGeneratedProps,
} from "../Sections/_generated/HomeEightServiceSlider.generated";
import HomeEightSliderOneGenerated, {
  HomeEightSliderOneGeneratedProps,
} from "../Sections/_generated/HomeEightSliderOne.generated";
import HomeEightSupportSectionGenerated, {
  HomeEightSupportSectionGeneratedProps,
} from "../Sections/_generated/HomeEightSupportSection.generated";
import HomeEightTeamSectionGenerated, {
  HomeEightTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeEightTeamSection.generated";
import HomeEightVideoSectionGenerated, {
  HomeEightVideoSectionGeneratedProps,
} from "../Sections/_generated/HomeEightVideoSection.generated";
import HomeEighteenBlogSectionGenerated, {
  HomeEighteenBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenBlogSection.generated";
import HomeEighteenChooseSectionGenerated, {
  HomeEighteenChooseSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenChooseSection.generated";
import HomeEighteenFaqSectionGenerated, {
  HomeEighteenFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenFaqSection.generated";
import HomeEighteenHelpSectionGenerated, {
  HomeEighteenHelpSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenHelpSection.generated";
import HomeEighteenReadySectionGenerated, {
  HomeEighteenReadySectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenReadySection.generated";
import HomeEighteenServicesSectionGenerated, {
  HomeEighteenServicesSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenServicesSection.generated";
import HomeEighteenSliderSectionGenerated, {
  HomeEighteenSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenSliderSection.generated";
import HomeEighteenTeamSectionGenerated, {
  HomeEighteenTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenTeamSection.generated";
import HomeEighteenTestimonialSectionGenerated, {
  HomeEighteenTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenTestimonialSection.generated";
import HomeEighteenWhyChooseSectionGenerated, {
  HomeEighteenWhyChooseSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenWhyChooseSection.generated";
import HomeEighteenWorkSectionGenerated, {
  HomeEighteenWorkSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenWorkSection.generated";
import HomeElevenBlogsSectionGenerated, {
  HomeElevenBlogsSectionGeneratedProps,
} from "../Sections/_generated/HomeElevenBlogsSection.generated";
import HomeElevenChooseusSectionGenerated, {
  HomeElevenChooseusSectionGeneratedProps,
} from "../Sections/_generated/HomeElevenChooseusSection.generated";
import HomeElevenServicesSectionGenerated, {
  HomeElevenServicesSectionGeneratedProps,
} from "../Sections/_generated/HomeElevenServicesSection.generated";
import HomeElevenTeamsSectionGenerated, {
  HomeElevenTeamsSectionGeneratedProps,
} from "../Sections/_generated/HomeElevenTeamsSection.generated";
import HomeElevenTestimonailSectionGenerated, {
  HomeElevenTestimonailSectionGeneratedProps,
} from "../Sections/_generated/HomeElevenTestimonailSection.generated";
import HomeElevenWorkSectionGenerated, {
  HomeElevenWorkSectionGeneratedProps,
} from "../Sections/_generated/HomeElevenWorkSection.generated";
import HomeFifteenBlogSectionGenerated, {
  HomeFifteenBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenBlogSection.generated";
import HomeFifteenChooseUsSectionGenerated, {
  HomeFifteenChooseUsSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenChooseUsSection.generated";
import HomeFifteenCompanySectionGenerated, {
  HomeFifteenCompanySectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenCompanySection.generated";
import HomeFifteenCounterSectionGenerated, {
  HomeFifteenCounterSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenCounterSection.generated";
import HomeFifteenExpertsSectionGenerated, {
  HomeFifteenExpertsSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenExpertsSection.generated";
import HomeFifteenFaqSectionGenerated, {
  HomeFifteenFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenFaqSection.generated";
import HomeFifteenItSectionGenerated, {
  HomeFifteenItSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenItSection.generated";
import HomeFifteenOfferSectionGenerated, {
  HomeFifteenOfferSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenOfferSection.generated";
import HomeFifteenStartSliderSectionGenerated, {
  HomeFifteenStartSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenStartSliderSection.generated";
import HomeFifteenSupportSectionGenerated, {
  HomeFifteenSupportSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenSupportSection.generated";
import HomeFifteenTeamSectionGenerated, {
  HomeFifteenTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenTeamSection.generated";
import HomeFiveChooseSectionGenerated, {
  HomeFiveChooseSectionGeneratedProps,
} from "../Sections/_generated/HomeFiveChooseSection.generated";
import HomeFiveJourneySectionGenerated, {
  HomeFiveJourneySectionGeneratedProps,
} from "../Sections/_generated/HomeFiveJourneySection.generated";
import HomeFiveReviewsSectionGenerated, {
  HomeFiveReviewsSectionGeneratedProps,
} from "../Sections/_generated/HomeFiveReviewsSection.generated";
import HomeFiveServiceSectionGenerated, {
  HomeFiveServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeFiveServiceSection.generated";
import HomeFiveSliderSectionGenerated, {
  HomeFiveSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeFiveSliderSection.generated";
import HomeFiveStartNewsSectionGenerated, {
  HomeFiveStartNewsSectionGeneratedProps,
} from "../Sections/_generated/HomeFiveStartNewsSection.generated";
import HomeFiveTeamSectionGenerated, {
  HomeFiveTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeFiveTeamSection.generated";
import HomeFourBlogSectionGenerated, {
  HomeFourBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeFourBlogSection.generated";
import HomeFourCounterSectionGenerated, {
  HomeFourCounterSectionGeneratedProps,
} from "../Sections/_generated/HomeFourCounterSection.generated";
import HomeFourDoctorSectionGenerated, {
  HomeFourDoctorSectionGeneratedProps,
} from "../Sections/_generated/HomeFourDoctorSection.generated";
import HomeFourFaqSectionGenerated, {
  HomeFourFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeFourFaqSection.generated";
import HomeFourPartnersSectionGenerated, {
  HomeFourPartnersSectionGeneratedProps,
} from "../Sections/_generated/HomeFourPartnersSection.generated";
import HomeFourServiceSectiionGenerated, {
  HomeFourServiceSectiionGeneratedProps,
} from "../Sections/_generated/HomeFourServiceSectiion.generated";
import HomeFourSliderSectionGenerated, {
  HomeFourSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeFourSliderSection.generated";
import HomeFourTestimonialSectionGenerated, {
  HomeFourTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeFourTestimonialSection.generated";
import HomeFourVideoSectionGenerated, {
  HomeFourVideoSectionGeneratedProps,
} from "../Sections/_generated/HomeFourVideoSection.generated";
import HomeFourteenBlogsSectionGenerated, {
  HomeFourteenBlogsSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenBlogsSection.generated";
import HomeFourteenChooseSectionGenerated, {
  HomeFourteenChooseSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenChooseSection.generated";
import HomeFourteenFaqSectionGenerated, {
  HomeFourteenFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenFaqSection.generated";
import HomeFourteenServicesSectionGenerated, {
  HomeFourteenServicesSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenServicesSection.generated";
import HomeFourteenStartSliderSectionGenerated, {
  HomeFourteenStartSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenStartSliderSection.generated";
import HomeFourteenTeamSectionGenerated, {
  HomeFourteenTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenTeamSection.generated";
import HomeFourteenTeamSectionTwoGenerated, {
  HomeFourteenTeamSectionTwoGeneratedProps,
} from "../Sections/_generated/HomeFourteenTeamSectionTwo.generated";
import HomeFourteenTestimonialsSectionGenerated, {
  HomeFourteenTestimonialsSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenTestimonialsSection.generated";
import HomeFourteenTreatmentSectionGenerated, {
  HomeFourteenTreatmentSectionGeneratedProps,
} from "../Sections/_generated/HomeFourteenTreatmentSection.generated";
import HomeNineArticleSectionGenerated, {
  HomeNineArticleSectionGeneratedProps,
} from "../Sections/_generated/HomeNineArticleSection.generated";
import HomeNineCompanySliderGenerated, {
  HomeNineCompanySliderGeneratedProps,
} from "../Sections/_generated/HomeNineCompanySlider.generated";
import HomeNineHealthSectionGenerated, {
  HomeNineHealthSectionGeneratedProps,
} from "../Sections/_generated/HomeNineHealthSection.generated";
import HomeNineJourneySectionGenerated, {
  HomeNineJourneySectionGeneratedProps,
} from "../Sections/_generated/HomeNineJourneySection.generated";
import HomeNineServiceSectionGenerated, {
  HomeNineServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeNineServiceSection.generated";
import HomeNineServiceSliderGenerated, {
  HomeNineServiceSliderGeneratedProps,
} from "../Sections/_generated/HomeNineServiceSlider.generated";
import HomeNineTeamSectionGenerated, {
  HomeNineTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeNineTeamSection.generated";
import HomeNineTestimonialSectionGenerated, {
  HomeNineTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeNineTestimonialSection.generated";
import HomeNineWhyChooseSectionGenerated, {
  HomeNineWhyChooseSectionGeneratedProps,
} from "../Sections/_generated/HomeNineWhyChooseSection.generated";
import HomeOneAppSectionGenerated, {
  HomeOneAppSectionGeneratedProps,
} from "../Sections/_generated/HomeOneAppSection.generated";
import HomeOneArticleSectionGenerated, {
  HomeOneArticleSectionGeneratedProps,
} from "../Sections/_generated/HomeOneArticleSection.generated";
import HomeOneBookusSectionGenerated, {
  HomeOneBookusSectionGeneratedProps,
} from "../Sections/_generated/HomeOneBookusSection.generated";
import HomeOneCompanySectionGenerated, {
  HomeOneCompanySectionGeneratedProps,
} from "../Sections/_generated/HomeOneCompanySection.generated";
import HomeOneDoctorSectionGenerated, {
  HomeOneDoctorSectionGeneratedProps,
} from "../Sections/_generated/HomeOneDoctorSection.generated";
import HomeOneFaqSectionGenerated, {
  HomeOneFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeOneFaqSection.generated";
import HomeOneInfoSectionGenerated, {
  HomeOneInfoSectionGeneratedProps,
} from "../Sections/_generated/HomeOneInfoSection.generated";
import HomeOneListGenerated, {
  HomeOneListGeneratedProps,
} from "../Sections/_generated/HomeOneList.generated";
import HomeOneReasonsSectionGenerated, {
  HomeOneReasonsSectionGeneratedProps,
} from "../Sections/_generated/HomeOneReasonsSection.generated";
import HomeOneServicesSectionGenerated, {
  HomeOneServicesSectionGeneratedProps,
} from "../Sections/_generated/HomeOneServicesSection.generated";
import HomeOneTestimonialSectionGenerated, {
  HomeOneTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeOneTestimonialSection.generated";
import HomeSevenAppointmentSectionGenerated, {
  HomeSevenAppointmentSectionGeneratedProps,
} from "../Sections/_generated/HomeSevenAppointmentSection.generated";
import HomeSevenBlogSectionGenerated, {
  HomeSevenBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeSevenBlogSection.generated";
import HomeSevenServiceSectionGenerated, {
  HomeSevenServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeSevenServiceSection.generated";
import HomeSevenSliderSectionGenerated, {
  HomeSevenSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeSevenSliderSection.generated";
import HomeSevenTeamSectionGenerated, {
  HomeSevenTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeSevenTeamSection.generated";
import HomeSevenTestimonialSectionGenerated, {
  HomeSevenTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeSevenTestimonialSection.generated";
import HomeSevenWorkSectionGenerated, {
  HomeSevenWorkSectionGeneratedProps,
} from "../Sections/_generated/HomeSevenWorkSection.generated";
import HomeSeventeenBlogSectionGenerated, {
  HomeSeventeenBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenBlogSection.generated";
import HomeSeventeenChooseSectionGenerated, {
  HomeSeventeenChooseSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenChooseSection.generated";
import HomeSeventeenCounterSectionGenerated, {
  HomeSeventeenCounterSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenCounterSection.generated";
import HomeSeventeenFaqSectionGenerated, {
  HomeSeventeenFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenFaqSection.generated";
import HomeSeventeenPreviewSectionGenerated, {
  HomeSeventeenPreviewSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenPreviewSection.generated";
import HomeSeventeenServicesSectionGenerated, {
  HomeSeventeenServicesSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenServicesSection.generated";
import HomeSeventeenSliderSectionGenerated, {
  HomeSeventeenSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenSliderSection.generated";
import HomeSeventeenTeamSectionGenerated, {
  HomeSeventeenTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenTeamSection.generated";
import HomeSeventeenTestimonialSectionGenerated, {
  HomeSeventeenTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenTestimonialSection.generated";
import HomeSeventeenWellnessSectionGenerated, {
  HomeSeventeenWellnessSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenWellnessSection.generated";
import HomeSeventeenYogaSectionGenerated, {
  HomeSeventeenYogaSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenYogaSection.generated";
import HomeSixFaqSectionGenerated, {
  HomeSixFaqSectionGeneratedProps,
} from "../Sections/_generated/HomeSixFaqSection.generated";
import HomeSixServiceSectionGenerated, {
  HomeSixServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeSixServiceSection.generated";
import HomeSixSlideSectionGenerated, {
  HomeSixSlideSectionGeneratedProps,
} from "../Sections/_generated/HomeSixSlideSection.generated";
import HomeSixSubscribeSectionGenerated, {
  HomeSixSubscribeSectionGeneratedProps,
} from "../Sections/_generated/HomeSixSubscribeSection.generated";
import HomeSixTeamSectionGenerated, {
  HomeSixTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeSixTeamSection.generated";
import HomeSixTestimonialSectionGenerated, {
  HomeSixTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeSixTestimonialSection.generated";
import HomeSixTestimonialSectionTwoGenerated, {
  HomeSixTestimonialSectionTwoGeneratedProps,
} from "../Sections/_generated/HomeSixTestimonialSectionTwo.generated";
import HomeSixWhySectionGenerated, {
  HomeSixWhySectionGeneratedProps,
} from "../Sections/_generated/HomeSixWhySection.generated";
import HomeSixteenBlogSectionGenerated, {
  HomeSixteenBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenBlogSection.generated";
import HomeSixteenChooseUsSectionGenerated, {
  HomeSixteenChooseUsSectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenChooseUsSection.generated";
import HomeSixteenCompanySectionGenerated, {
  HomeSixteenCompanySectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenCompanySection.generated";
import HomeSixteenServicesSectionGenerated, {
  HomeSixteenServicesSectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenServicesSection.generated";
import HomeSixteenSliderSectionGenerated, {
  HomeSixteenSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenSliderSection.generated";
import HomeSixteenTeamSectionGenerated, {
  HomeSixteenTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenTeamSection.generated";
import HomeSixteenTestimonialSectionGenerated, {
  HomeSixteenTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenTestimonialSection.generated";
import HomeSixteenVideoSectionGenerated, {
  HomeSixteenVideoSectionGeneratedProps,
} from "../Sections/_generated/HomeSixteenVideoSection.generated";
import HomeTenBlogSectionGenerated, {
  HomeTenBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeTenBlogSection.generated";
import HomeTenChooseusSectionGenerated, {
  HomeTenChooseusSectionGeneratedProps,
} from "../Sections/_generated/HomeTenChooseusSection.generated";
import HomeTenPartnerSectionGenerated, {
  HomeTenPartnerSectionGeneratedProps,
} from "../Sections/_generated/HomeTenPartnerSection.generated";
import HomeTenServiceSectionGenerated, {
  HomeTenServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeTenServiceSection.generated";
import HomeTenSliderSectionGenerated, {
  HomeTenSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeTenSliderSection.generated";
import HomeTenTeamSectionGenerated, {
  HomeTenTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeTenTeamSection.generated";
import HomeTenTestimonialSectionGenerated, {
  HomeTenTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeTenTestimonialSection.generated";
import HomeTenWorkSectionGenerated, {
  HomeTenWorkSectionGeneratedProps,
} from "../Sections/_generated/HomeTenWorkSection.generated";
import HomeThirteenBlogSectionGenerated, {
  HomeThirteenBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenBlogSection.generated";
import HomeThirteenBrandSectionGenerated, {
  HomeThirteenBrandSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenBrandSection.generated";
import HomeThirteenDownloadSectionGenerated, {
  HomeThirteenDownloadSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenDownloadSection.generated";
import HomeThirteenHealthSectionGenerated, {
  HomeThirteenHealthSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenHealthSection.generated";
import HomeThirteenOfferSectionGenerated, {
  HomeThirteenOfferSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenOfferSection.generated";
import HomeThirteenServiceSliderThirteenGenerated, {
  HomeThirteenServiceSliderThirteenGeneratedProps,
} from "../Sections/_generated/HomeThirteenServiceSliderThirteen.generated";
import HomeThirteenShippingSectionGenerated, {
  HomeThirteenShippingSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenShippingSection.generated";
import HomeThirteenTechnologySectionGenerated, {
  HomeThirteenTechnologySectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenTechnologySection.generated";
import HomeThirteenTestimonialSectionGenerated, {
  HomeThirteenTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenTestimonialSection.generated";
import HomeThreeBlogSectionGenerated, {
  HomeThreeBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeBlogSection.generated";
import HomeThreeChooseSectionGenerated, {
  HomeThreeChooseSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeChooseSection.generated";
import HomeThreeHealthSectionGenerated, {
  HomeThreeHealthSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeHealthSection.generated";
import HomeThreeMissionSectionGenerated, {
  HomeThreeMissionSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeMissionSection.generated";
import HomeThreeServicesSectionGenerated, {
  HomeThreeServicesSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeServicesSection.generated";
import HomeThreeTeamSectionGenerated, {
  HomeThreeTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeTeamSection.generated";
import HomeThreeTechnologySectionGenerated, {
  HomeThreeTechnologySectionGeneratedProps,
} from "../Sections/_generated/HomeThreeTechnologySection.generated";
import HomeThreeTestimonialsSectionGenerated, {
  HomeThreeTestimonialsSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeTestimonialsSection.generated";
import HomeTwelveBlogSectionGenerated, {
  HomeTwelveBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveBlogSection.generated";
import HomeTwelveServiceSectionGenerated, {
  HomeTwelveServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveServiceSection.generated";
import HomeTwelveServiceSliderGenerated, {
  HomeTwelveServiceSliderGeneratedProps,
} from "../Sections/_generated/HomeTwelveServiceSlider.generated";
import HomeTwelveTeamSectionGenerated, {
  HomeTwelveTeamSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveTeamSection.generated";
import HomeTwelveTestPlanSectionGenerated, {
  HomeTwelveTestPlanSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveTestPlanSection.generated";
import HomeTwelveTestSectionGenerated, {
  HomeTwelveTestSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveTestSection.generated";
import HomeTwelveTestimonialSectionGenerated, {
  HomeTwelveTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveTestimonialSection.generated";
import HomeTwelveWorkSectionGenerated, {
  HomeTwelveWorkSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveWorkSection.generated";
import HomeTwoAppSectionGenerated, {
  HomeTwoAppSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoAppSection.generated";
import HomeTwoBlogSectionGenerated, {
  HomeTwoBlogSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoBlogSection.generated";
import HomeTwoDoctorSectionGenerated, {
  HomeTwoDoctorSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoDoctorSection.generated";
import HomeTwoHealthSectionGenerated, {
  HomeTwoHealthSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoHealthSection.generated";
import HomeTwoServiceSectionGenerated, {
  HomeTwoServiceSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoServiceSection.generated";
import HomeTwoSliderSectionGenerated, {
  HomeTwoSliderSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoSliderSection.generated";
import HomeTwoSpecialitySectionTwoGenerated, {
  HomeTwoSpecialitySectionTwoGeneratedProps,
} from "../Sections/_generated/HomeTwoSpecialitySectionTwo.generated";
import HomeTwoTestimonialSectionGenerated, {
  HomeTwoTestimonialSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoTestimonialSection.generated";
import HomeTwoWorkSectionGenerated, {
  HomeTwoWorkSectionGeneratedProps,
} from "../Sections/_generated/HomeTwoWorkSection.generated";
import {
  buildGeneratedSectionProps,
  createGeneratedRenderer,
  GeneratedSectionRenderer,
} from "./generated-section-renderer";

export const alertsRenderers: Record<
  string,
  GeneratedSectionRenderer<AlertsSectionProps>
> = {
  Home1: createGeneratedRenderer<
    AlertsSectionProps,
    HomeOneServicesSectionGeneratedProps
  >(HomeOneServicesSectionGenerated, "HomeOneServicesSection"),
  Home2: createGeneratedRenderer<
    AlertsSectionProps,
    HomeTwoSliderSectionGeneratedProps
  >(HomeTwoSliderSectionGenerated, "HomeTwoSliderSection"),
  Home4: createGeneratedRenderer<
    AlertsSectionProps,
    HomeFourSliderSectionGeneratedProps
  >(HomeFourSliderSectionGenerated, "HomeFourSliderSection"),
  Home5: createGeneratedRenderer<
    AlertsSectionProps,
    HomeFiveSliderSectionGeneratedProps
  >(HomeFiveSliderSectionGenerated, "HomeFiveSliderSection"),
  Home6: createGeneratedRenderer<
    AlertsSectionProps,
    HomeSixSlideSectionGeneratedProps
  >(HomeSixSlideSectionGenerated, "HomeSixSlideSection"),
  Home7: createGeneratedRenderer<
    AlertsSectionProps,
    HomeSevenSliderSectionGeneratedProps
  >(HomeSevenSliderSectionGenerated, "HomeSevenSliderSection"),
  Home8: createGeneratedRenderer<
    AlertsSectionProps,
    HomeEightSliderOneGeneratedProps
  >(HomeEightSliderOneGenerated, "HomeEightSliderOne"),
  Home10: createGeneratedRenderer<
    AlertsSectionProps,
    HomeTenSliderSectionGeneratedProps
  >(HomeTenSliderSectionGenerated, "HomeTenSliderSection"),
  Home14: createGeneratedRenderer<
    AlertsSectionProps,
    HomeFourteenStartSliderSectionGeneratedProps
  >(HomeFourteenStartSliderSectionGenerated, "HomeFourteenStartSliderSection"),
  Home15: createGeneratedRenderer<
    AlertsSectionProps,
    HomeFifteenStartSliderSectionGeneratedProps
  >(HomeFifteenStartSliderSectionGenerated, "HomeFifteenStartSliderSection"),
  Home16: createGeneratedRenderer<
    AlertsSectionProps,
    HomeSixteenSliderSectionGeneratedProps
  >(HomeSixteenSliderSectionGenerated, "HomeSixteenSliderSection"),
  Home17: createGeneratedRenderer<
    AlertsSectionProps,
    HomeSeventeenSliderSectionGeneratedProps
  >(HomeSeventeenSliderSectionGenerated, "HomeSeventeenSliderSection"),
  Home18: createGeneratedRenderer<
    AlertsSectionProps,
    HomeEighteenSliderSectionGeneratedProps
  >(HomeEighteenSliderSectionGenerated, "HomeEighteenSliderSection"),
};

export const appRenderers: Record<
  string,
  GeneratedSectionRenderer<AppSectionProps>
> = {
  Home1: createGeneratedRenderer<
    AppSectionProps,
    HomeOneAppSectionGeneratedProps
  >(HomeOneAppSectionGenerated, "HomeOneAppSection"),
  Home2: createGeneratedRenderer<
    AppSectionProps,
    HomeTwoAppSectionGeneratedProps
  >(HomeTwoAppSectionGenerated, "HomeTwoAppSection"),
  Home13: createGeneratedRenderer<
    AppSectionProps,
    HomeThirteenDownloadSectionGeneratedProps
  >(HomeThirteenDownloadSectionGenerated, "HomeThirteenDownloadSection"),
};

export const appointmentRenderers: Record<
  string,
  GeneratedSectionRenderer<AppointmentSectionProps>
> = {
  Home1: createGeneratedRenderer<
    AppointmentSectionProps,
    HomeOneBookusSectionGeneratedProps
  >(HomeOneBookusSectionGenerated, "HomeOneBookusSection"),
  Home5: createGeneratedRenderer<
    AppointmentSectionProps,
    HomeFiveJourneySectionGeneratedProps
  >(HomeFiveJourneySectionGenerated, "HomeFiveJourneySection"),
  Home7: createGeneratedRenderer<
    AppointmentSectionProps,
    HomeSevenAppointmentSectionGeneratedProps
  >(HomeSevenAppointmentSectionGenerated, "HomeSevenAppointmentSection"),
  Home8: createGeneratedRenderer<
    AppointmentSectionProps,
    HomeEightBookSectionGeneratedProps
  >(HomeEightBookSectionGenerated, "HomeEightBookSection"),
  Home9: createGeneratedRenderer<
    AppointmentSectionProps,
    HomeNineJourneySectionGeneratedProps
  >(HomeNineJourneySectionGenerated, "HomeNineJourneySection"),
  Home15: createGeneratedRenderer<
    AppointmentSectionProps,
    HomeFifteenItSectionGeneratedProps
  >(HomeFifteenItSectionGenerated, "HomeFifteenItSection"),
};

export const blogsRenderers: Record<
  string,
  GeneratedSectionRenderer<BlogsSectionProps>
> = {
  Home1: createGeneratedRenderer<
    BlogsSectionProps,
    HomeOneArticleSectionGeneratedProps
  >(HomeOneArticleSectionGenerated, "HomeOneArticleSection"),
  Home2: createGeneratedRenderer<
    BlogsSectionProps,
    HomeTwoBlogSectionGeneratedProps
  >(HomeTwoBlogSectionGenerated, "HomeTwoBlogSection"),
  Home3: createGeneratedRenderer<
    BlogsSectionProps,
    HomeThreeBlogSectionGeneratedProps
  >(HomeThreeBlogSectionGenerated, "HomeThreeBlogSection"),
  Home4: createGeneratedRenderer<
    BlogsSectionProps,
    HomeFourBlogSectionGeneratedProps
  >(HomeFourBlogSectionGenerated, "HomeFourBlogSection"),
  Home5: createGeneratedRenderer<
    BlogsSectionProps,
    HomeFiveStartNewsSectionGeneratedProps
  >(HomeFiveStartNewsSectionGenerated, "HomeFiveStartNewsSection"),
  Home6: createGeneratedRenderer<
    BlogsSectionProps,
    HomeSixTestimonialSectionTwoGeneratedProps
  >(HomeSixTestimonialSectionTwoGenerated, "HomeSixTestimonialSectionTwo"),
  Home7: createGeneratedRenderer<
    BlogsSectionProps,
    HomeSevenBlogSectionGeneratedProps
  >(HomeSevenBlogSectionGenerated, "HomeSevenBlogSection"),
  Home8: createGeneratedRenderer<
    BlogsSectionProps,
    HomeEightBlogSectionGeneratedProps
  >(HomeEightBlogSectionGenerated, "HomeEightBlogSection"),
  Home9: createGeneratedRenderer<
    BlogsSectionProps,
    HomeNineArticleSectionGeneratedProps
  >(HomeNineArticleSectionGenerated, "HomeNineArticleSection"),
  Home10: createGeneratedRenderer<
    BlogsSectionProps,
    HomeTenBlogSectionGeneratedProps
  >(HomeTenBlogSectionGenerated, "HomeTenBlogSection"),
  Home11: createGeneratedRenderer<
    BlogsSectionProps,
    HomeElevenBlogsSectionGeneratedProps
  >(HomeElevenBlogsSectionGenerated, "HomeElevenBlogsSection"),
  Home12: createGeneratedRenderer<
    BlogsSectionProps,
    HomeTwelveBlogSectionGeneratedProps
  >(HomeTwelveBlogSectionGenerated, "HomeTwelveBlogSection"),
  Home13: createGeneratedRenderer<
    BlogsSectionProps,
    HomeThirteenBlogSectionGeneratedProps
  >(HomeThirteenBlogSectionGenerated, "HomeThirteenBlogSection"),
  Home14: createGeneratedRenderer<
    BlogsSectionProps,
    HomeFourteenBlogsSectionGeneratedProps
  >(HomeFourteenBlogsSectionGenerated, "HomeFourteenBlogsSection"),
  Home15: createGeneratedRenderer<
    BlogsSectionProps,
    HomeFifteenBlogSectionGeneratedProps
  >(HomeFifteenBlogSectionGenerated, "HomeFifteenBlogSection"),
  Home16: createGeneratedRenderer<
    BlogsSectionProps,
    HomeSixteenBlogSectionGeneratedProps
  >(HomeSixteenBlogSectionGenerated, "HomeSixteenBlogSection"),
  Home17: createGeneratedRenderer<
    BlogsSectionProps,
    HomeSeventeenBlogSectionGeneratedProps
  >(HomeSeventeenBlogSectionGenerated, "HomeSeventeenBlogSection"),
  Home18: createGeneratedRenderer<
    BlogsSectionProps,
    HomeEighteenBlogSectionGeneratedProps
  >(HomeEighteenBlogSectionGenerated, "HomeEighteenBlogSection"),
};

export const chooseUsRenderers: Record<
  string,
  GeneratedSectionRenderer<ChooseUsSectionProps>
> = {
  Home3: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeThreeChooseSectionGeneratedProps
  >(HomeThreeChooseSectionGenerated, "HomeThreeChooseSection"),
  Home5: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeFiveChooseSectionGeneratedProps
  >(HomeFiveChooseSectionGenerated, "HomeFiveChooseSection"),
  Home10: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeTenChooseusSectionGeneratedProps
  >(HomeTenChooseusSectionGenerated, "HomeTenChooseusSection"),
  Home11: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeElevenChooseusSectionGeneratedProps
  >(HomeElevenChooseusSectionGenerated, "HomeElevenChooseusSection"),
  Home14: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeFourteenChooseSectionGeneratedProps
  >(HomeFourteenChooseSectionGenerated, "HomeFourteenChooseSection"),
  Home15: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeFifteenChooseUsSectionGeneratedProps
  >(HomeFifteenChooseUsSectionGenerated, "HomeFifteenChooseUsSection"),
  Home16: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeSixteenChooseUsSectionGeneratedProps
  >(HomeSixteenChooseUsSectionGenerated, "HomeSixteenChooseUsSection"),
  Home17: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeSeventeenChooseSectionGeneratedProps
  >(HomeSeventeenChooseSectionGenerated, "HomeSeventeenChooseSection"),
  Home18: createGeneratedRenderer<
    ChooseUsSectionProps,
    HomeEighteenChooseSectionGeneratedProps
  >(HomeEighteenChooseSectionGenerated, "HomeEighteenChooseSection"),
};

export const commentsRenderers: Record<
  string,
  GeneratedSectionRenderer<CommentsSectionProps>
> = {
  Home1: createGeneratedRenderer<
    CommentsSectionProps,
    HomeOneTestimonialSectionGeneratedProps
  >(HomeOneTestimonialSectionGenerated, "HomeOneTestimonialSection"),
  Home2: createGeneratedRenderer<
    CommentsSectionProps,
    HomeTwoTestimonialSectionGeneratedProps
  >(HomeTwoTestimonialSectionGenerated, "HomeTwoTestimonialSection"),
  Home3: createGeneratedRenderer<
    CommentsSectionProps,
    HomeThreeTestimonialsSectionGeneratedProps
  >(HomeThreeTestimonialsSectionGenerated, "HomeThreeTestimonialsSection"),
  Home4: createGeneratedRenderer<
    CommentsSectionProps,
    HomeFourTestimonialSectionGeneratedProps
  >(HomeFourTestimonialSectionGenerated, "HomeFourTestimonialSection"),
  Home5: createGeneratedRenderer<
    CommentsSectionProps,
    HomeFiveReviewsSectionGeneratedProps
  >(HomeFiveReviewsSectionGenerated, "HomeFiveReviewsSection"),
  Home6: createGeneratedRenderer<
    CommentsSectionProps,
    HomeSixTestimonialSectionGeneratedProps
  >(HomeSixTestimonialSectionGenerated, "HomeSixTestimonialSection"),
  Home7: createGeneratedRenderer<
    CommentsSectionProps,
    HomeSevenTestimonialSectionGeneratedProps
  >(HomeSevenTestimonialSectionGenerated, "HomeSevenTestimonialSection"),
  Home9: createGeneratedRenderer<
    CommentsSectionProps,
    HomeNineTestimonialSectionGeneratedProps
  >(HomeNineTestimonialSectionGenerated, "HomeNineTestimonialSection"),
  Home10: createGeneratedRenderer<
    CommentsSectionProps,
    HomeTenTestimonialSectionGeneratedProps
  >(HomeTenTestimonialSectionGenerated, "HomeTenTestimonialSection"),
  Home11: createGeneratedRenderer<
    CommentsSectionProps,
    HomeElevenTestimonailSectionGeneratedProps
  >(HomeElevenTestimonailSectionGenerated, "HomeElevenTestimonailSection"),
  Home12: createGeneratedRenderer<
    CommentsSectionProps,
    HomeTwelveTestimonialSectionGeneratedProps
  >(HomeTwelveTestimonialSectionGenerated, "HomeTwelveTestimonialSection"),
  Home13: createGeneratedRenderer<
    CommentsSectionProps,
    HomeThirteenTestimonialSectionGeneratedProps
  >(HomeThirteenTestimonialSectionGenerated, "HomeThirteenTestimonialSection"),
  Home14: createGeneratedRenderer<
    CommentsSectionProps,
    HomeFourteenTestimonialsSectionGeneratedProps
  >(
    HomeFourteenTestimonialsSectionGenerated,
    "HomeFourteenTestimonialsSection",
  ),
  Home15: createGeneratedRenderer<
    CommentsSectionProps,
    HomeFifteenExpertsSectionGeneratedProps
  >(HomeFifteenExpertsSectionGenerated, "HomeFifteenExpertsSection"),
  Home16: createGeneratedRenderer<
    CommentsSectionProps,
    HomeSixteenTestimonialSectionGeneratedProps
  >(HomeSixteenTestimonialSectionGenerated, "HomeSixteenTestimonialSection"),
  Home17: createGeneratedRenderer<
    CommentsSectionProps,
    HomeSeventeenTestimonialSectionGeneratedProps
  >(
    HomeSeventeenTestimonialSectionGenerated,
    "HomeSeventeenTestimonialSection",
  ),
  Home18: createGeneratedRenderer<
    CommentsSectionProps,
    HomeEighteenTestimonialSectionGeneratedProps
  >(HomeEighteenTestimonialSectionGenerated, "HomeEighteenTestimonialSection"),
};

export const doctorsRenderers: Record<
  string,
  GeneratedSectionRenderer<DoctorsSectionProps>
> = {
  Home1: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeOneDoctorSectionGeneratedProps
  >(HomeOneDoctorSectionGenerated, "HomeOneDoctorSection"),
  Home2: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeTwoDoctorSectionGeneratedProps
  >(HomeTwoDoctorSectionGenerated, "HomeTwoDoctorSection"),
  Home3: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeThreeTeamSectionGeneratedProps
  >(HomeThreeTeamSectionGenerated, "HomeThreeTeamSection"),
  Home4: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeFourDoctorSectionGeneratedProps
  >(HomeFourDoctorSectionGenerated, "HomeFourDoctorSection"),
  Home5: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeFiveTeamSectionGeneratedProps
  >(HomeFiveTeamSectionGenerated, "HomeFiveTeamSection"),
  Home6: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeSixTeamSectionGeneratedProps
  >(HomeSixTeamSectionGenerated, "HomeSixTeamSection"),
  Home7: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeSevenTeamSectionGeneratedProps
  >(HomeSevenTeamSectionGenerated, "HomeSevenTeamSection"),
  Home8: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeEightTeamSectionGeneratedProps
  >(HomeEightTeamSectionGenerated, "HomeEightTeamSection"),
  Home9: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeNineTeamSectionGeneratedProps
  >(HomeNineTeamSectionGenerated, "HomeNineTeamSection"),
  Home10: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeTenTeamSectionGeneratedProps
  >(HomeTenTeamSectionGenerated, "HomeTenTeamSection"),
  Home11: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeElevenTeamsSectionGeneratedProps
  >(HomeElevenTeamsSectionGenerated, "HomeElevenTeamsSection"),
  Home12: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeTwelveTeamSectionGeneratedProps
  >(HomeTwelveTeamSectionGenerated, "HomeTwelveTeamSection"),
  Home14: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeFourteenTeamSectionTwoGeneratedProps
  >(HomeFourteenTeamSectionTwoGenerated, "HomeFourteenTeamSectionTwo"),
  Home15: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeFifteenTeamSectionGeneratedProps
  >(HomeFifteenTeamSectionGenerated, "HomeFifteenTeamSection"),
  Home16: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeSixteenTeamSectionGeneratedProps
  >(HomeSixteenTeamSectionGenerated, "HomeSixteenTeamSection"),
  Home17: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeSeventeenTeamSectionGeneratedProps
  >(HomeSeventeenTeamSectionGenerated, "HomeSeventeenTeamSection"),
  Home18: createGeneratedRenderer<
    DoctorsSectionProps,
    HomeEighteenTeamSectionGeneratedProps
  >(HomeEighteenTeamSectionGenerated, "HomeEighteenTeamSection"),
};

export const faqRenderers: Record<
  string,
  GeneratedSectionRenderer<FaqSectionProps>
> = {
  Home1: createGeneratedRenderer<
    FaqSectionProps,
    HomeOneFaqSectionGeneratedProps
  >(HomeOneFaqSectionGenerated, "HomeOneFaqSection"),
  Home4: (props) => (
    <HomeFourFaqSectionGenerated
      {...buildGeneratedSectionProps<HomeFourFaqSectionGeneratedProps>(
        "HomeFourFaqSection",
        {
          sectionDiv0Div0Div0Div0Div0DivText:
            props.setting.Subtitle ?? undefined,
        },
      )}
    />
  ),
  Home6: createGeneratedRenderer<
    FaqSectionProps,
    HomeSixFaqSectionGeneratedProps
  >(HomeSixFaqSectionGenerated, "HomeSixFaqSection"),
  Home8: createGeneratedRenderer<
    FaqSectionProps,
    HomeEightFaqSectionGeneratedProps
  >(HomeEightFaqSectionGenerated, "HomeEightFaqSection"),
  Home14: createGeneratedRenderer<
    FaqSectionProps,
    HomeFourteenFaqSectionGeneratedProps
  >(HomeFourteenFaqSectionGenerated, "HomeFourteenFaqSection"),
  Home15: createGeneratedRenderer<
    FaqSectionProps,
    HomeFifteenFaqSectionGeneratedProps
  >(HomeFifteenFaqSectionGenerated, "HomeFifteenFaqSection"),
  Home17: createGeneratedRenderer<
    FaqSectionProps,
    HomeSeventeenFaqSectionGeneratedProps
  >(HomeSeventeenFaqSectionGenerated, "HomeSeventeenFaqSection"),
  Home18: createGeneratedRenderer<
    FaqSectionProps,
    HomeEighteenFaqSectionGeneratedProps
  >(HomeEighteenFaqSectionGenerated, "HomeEighteenFaqSection"),
};

export const featuresRenderers: Record<
  string,
  GeneratedSectionRenderer<FeaturesSectionProps>
> = {
  Home1: createGeneratedRenderer<
    FeaturesSectionProps,
    HomeOneReasonsSectionGeneratedProps
  >(HomeOneReasonsSectionGenerated, "HomeOneReasonsSection"),
  Home12: createGeneratedRenderer<
    FeaturesSectionProps,
    HomeTwelveTestPlanSectionGeneratedProps
  >(HomeTwelveTestPlanSectionGenerated, "HomeTwelveTestPlanSection"),
  Home17: createGeneratedRenderer<
    FeaturesSectionProps,
    HomeSeventeenWellnessSectionGeneratedProps
  >(HomeSeventeenWellnessSectionGenerated, "HomeSeventeenWellnessSection"),
};

export const healthRenderers: Record<
  string,
  GeneratedSectionRenderer<HealthSectionProps>
> = {
  Home2: createGeneratedRenderer<
    HealthSectionProps,
    HomeTwoHealthSectionGeneratedProps
  >(HomeTwoHealthSectionGenerated, "HomeTwoHealthSection"),
  Home3: createGeneratedRenderer<
    HealthSectionProps,
    HomeThreeHealthSectionGeneratedProps
  >(HomeThreeHealthSectionGenerated, "HomeThreeHealthSection"),
  Home9: createGeneratedRenderer<
    HealthSectionProps,
    HomeNineHealthSectionGeneratedProps
  >(HomeNineHealthSectionGenerated, "HomeNineHealthSection"),
  Home13: createGeneratedRenderer<
    HealthSectionProps,
    HomeThirteenHealthSectionGeneratedProps
  >(HomeThirteenHealthSectionGenerated, "HomeThirteenHealthSection"),
};

export const headlineRenderers: Record<
  string,
  GeneratedSectionRenderer<HeadlineSectionProps>
> = {
  Home14: createGeneratedRenderer<
    HeadlineSectionProps,
    HomeFourteenTreatmentSectionGeneratedProps
  >(HomeFourteenTreatmentSectionGenerated, "HomeFourteenTreatmentSection"),
  Home17: createGeneratedRenderer<
    HeadlineSectionProps,
    HomeSeventeenPreviewSectionGeneratedProps
  >(HomeSeventeenPreviewSectionGenerated, "HomeSeventeenPreviewSection"),
  Home18: createGeneratedRenderer<
    HeadlineSectionProps,
    HomeEighteenReadySectionGeneratedProps
  >(HomeEighteenReadySectionGenerated, "HomeEighteenReadySection"),
};

export const helpRenderers: Record<
  string,
  GeneratedSectionRenderer<HelpSectionProps>
> = {
  Home18: createGeneratedRenderer<
    HelpSectionProps,
    HomeEighteenHelpSectionGeneratedProps
  >(HomeEighteenHelpSectionGenerated, "HomeEighteenHelpSection"),
};

export const infoRenderers: Record<
  string,
  GeneratedSectionRenderer<InfoSectionProps>
> = {
  Home1: createGeneratedRenderer<
    InfoSectionProps,
    HomeOneInfoSectionGeneratedProps
  >(HomeOneInfoSectionGenerated, "HomeOneInfoSection"),
};

export const insurancesRenderers: Record<
  string,
  GeneratedSectionRenderer<InsurancesSectionProps>
> = {
  Home1: (props) => (
    <HomeOneCompanySectionGenerated
      {...buildGeneratedSectionProps<HomeOneCompanySectionGeneratedProps>(
        "HomeOneCompanySection",
        { divDiv0Div0P0PText: props.setting.Title },
      )}
      companySectionSlides={props.dataSource.Items.map((item) => ({
        key: item.Id,
        src: item.ImageUrl,
        alt: item.Name,
      }))}
    />
  ),
  Home4: (props) => (
    <HomeFourPartnersSectionGenerated
      {...buildGeneratedSectionProps<HomeFourPartnersSectionGeneratedProps>(
        "HomeFourPartnersSection",
      )}
      partnersSectionPartnerFours={props.dataSource.Items.map((item) => ({
        key: item.Id,
        src: item.ImageUrl,
        alt: item.Name,
      }))}
    />
  ),
  Home8: createGeneratedRenderer<
    InsurancesSectionProps,
    HomeEightCompanySectionGeneratedProps
  >(HomeEightCompanySectionGenerated, "HomeEightCompanySection"),
  Home9: createGeneratedRenderer<
    InsurancesSectionProps,
    HomeNineCompanySliderGeneratedProps
  >(HomeNineCompanySliderGenerated, "HomeNineCompanySlider"),
  Home10: createGeneratedRenderer<
    InsurancesSectionProps,
    HomeTenPartnerSectionGeneratedProps
  >(HomeTenPartnerSectionGenerated, "HomeTenPartnerSection"),
  Home13: createGeneratedRenderer<
    InsurancesSectionProps,
    HomeThirteenBrandSectionGeneratedProps
  >(HomeThirteenBrandSectionGenerated, "HomeThirteenBrandSection"),
  Home15: createGeneratedRenderer<
    InsurancesSectionProps,
    HomeFifteenCompanySectionGeneratedProps
  >(HomeFifteenCompanySectionGenerated, "HomeFifteenCompanySection"),
  Home16: createGeneratedRenderer<
    InsurancesSectionProps,
    HomeSixteenCompanySectionGeneratedProps
  >(HomeSixteenCompanySectionGenerated, "HomeSixteenCompanySection"),
};

export const listRenderers: Record<
  string,
  GeneratedSectionRenderer<ListSectionProps>
> = {
  Home1: createGeneratedRenderer<ListSectionProps, HomeOneListGeneratedProps>(
    HomeOneListGenerated,
    "HomeOneList",
  ),
};

export const missionRenderers: Record<
  string,
  GeneratedSectionRenderer<MissionSectionProps>
> = {
  Home3: createGeneratedRenderer<
    MissionSectionProps,
    HomeThreeMissionSectionGeneratedProps
  >(HomeThreeMissionSectionGenerated, "HomeThreeMissionSection"),
};

export const newsletterRenderers: Record<
  string,
  GeneratedSectionRenderer<NewsletterSectionProps>
> = {
  Home6: createGeneratedRenderer<
    NewsletterSectionProps,
    HomeSixSubscribeSectionGeneratedProps
  >(HomeSixSubscribeSectionGenerated, "HomeSixSubscribeSection"),
};

export const offerRenderers: Record<
  string,
  GeneratedSectionRenderer<OfferSectionProps>
> = {
  Home13: createGeneratedRenderer<
    OfferSectionProps,
    HomeThirteenOfferSectionGeneratedProps
  >(HomeThirteenOfferSectionGenerated, "HomeThirteenOfferSection"),
  Home15: createGeneratedRenderer<
    OfferSectionProps,
    HomeFifteenOfferSectionGeneratedProps
  >(HomeFifteenOfferSectionGenerated, "HomeFifteenOfferSection"),
};

export const packagesRenderers: Record<
  string,
  GeneratedSectionRenderer<PackagesSectionProps>
> = {
  Home2: createGeneratedRenderer<
    PackagesSectionProps,
    HomeTwoSpecialitySectionTwoGeneratedProps
  >(HomeTwoSpecialitySectionTwoGenerated, "HomeTwoSpecialitySectionTwo"),
};

export const ourServicesRenderers: Record<
  string,
  GeneratedSectionRenderer<OurServicesSectionProps>
> = {
  Home2: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeTwoServiceSectionGeneratedProps
  >(HomeTwoServiceSectionGenerated, "HomeTwoServiceSection"),
  Home3: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeThreeServicesSectionGeneratedProps
  >(HomeThreeServicesSectionGenerated, "HomeThreeServicesSection"),
  Home4: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeFourServiceSectiionGeneratedProps
  >(HomeFourServiceSectiionGenerated, "HomeFourServiceSectiion"),
  Home5: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeFiveServiceSectionGeneratedProps
  >(HomeFiveServiceSectionGenerated, "HomeFiveServiceSection"),
  Home6: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeSixServiceSectionGeneratedProps
  >(HomeSixServiceSectionGenerated, "HomeSixServiceSection"),
  Home7: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeSevenServiceSectionGeneratedProps
  >(HomeSevenServiceSectionGenerated, "HomeSevenServiceSection"),
  Home9: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeNineServiceSectionGeneratedProps
  >(HomeNineServiceSectionGenerated, "HomeNineServiceSection"),
  Home10: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeTenServiceSectionGeneratedProps
  >(HomeTenServiceSectionGenerated, "HomeTenServiceSection"),
  Home11: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeElevenServicesSectionGeneratedProps
  >(HomeElevenServicesSectionGenerated, "HomeElevenServicesSection"),
  Home12: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeTwelveServiceSectionGeneratedProps
  >(HomeTwelveServiceSectionGenerated, "HomeTwelveServiceSection"),
  Home14: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeFourteenServicesSectionGeneratedProps
  >(HomeFourteenServicesSectionGenerated, "HomeFourteenServicesSection"),
  Home16: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeSixteenServicesSectionGeneratedProps
  >(HomeSixteenServicesSectionGenerated, "HomeSixteenServicesSection"),
  Home17: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeSeventeenServicesSectionGeneratedProps
  >(HomeSeventeenServicesSectionGenerated, "HomeSeventeenServicesSection"),
  Home18: createGeneratedRenderer<
    OurServicesSectionProps,
    HomeEighteenServicesSectionGeneratedProps
  >(HomeEighteenServicesSectionGenerated, "HomeEighteenServicesSection"),
};

export const serviceSliderRenderers: Record<
  string,
  GeneratedSectionRenderer<ServiceSliderSectionProps>
> = {
  Home8: createGeneratedRenderer<
    ServiceSliderSectionProps,
    HomeEightServiceSliderGeneratedProps
  >(HomeEightServiceSliderGenerated, "HomeEightServiceSlider"),
  Home9: createGeneratedRenderer<
    ServiceSliderSectionProps,
    HomeNineServiceSliderGeneratedProps
  >(HomeNineServiceSliderGenerated, "HomeNineServiceSlider"),
  Home12: createGeneratedRenderer<
    ServiceSliderSectionProps,
    HomeTwelveServiceSliderGeneratedProps
  >(HomeTwelveServiceSliderGenerated, "HomeTwelveServiceSlider"),
  Home13: createGeneratedRenderer<
    ServiceSliderSectionProps,
    HomeThirteenServiceSliderThirteenGeneratedProps
  >(
    HomeThirteenServiceSliderThirteenGenerated,
    "HomeThirteenServiceSliderThirteen",
  ),
};

export const shippingRenderers: Record<
  string,
  GeneratedSectionRenderer<ShippingSectionProps>
> = {
  Home13: createGeneratedRenderer<
    ShippingSectionProps,
    HomeThirteenShippingSectionGeneratedProps
  >(HomeThirteenShippingSectionGenerated, "HomeThirteenShippingSection"),
};

export const statisticsRenderers: Record<
  string,
  GeneratedSectionRenderer<StatisticsSectionProps>
> = {
  Home4: (props) => (
    <HomeFourCounterSectionGenerated
      {...buildGeneratedSectionProps<HomeFourCounterSectionGeneratedProps>(
        "HomeFourCounterSection",
        {
          sectionDiv0Div0H20H2Text: props.setting.Title ?? undefined,
          sectionDiv0Div0H20Span0SpanText: null,
          counterSection36s: props.lists.Items.map((item) => ({
            key: item.Id,
            h30Text: item.Value ?? undefined,
            p0Text: item.Title ?? undefined,
            div0h30Expr0: item.Value ?? undefined,
          })),
        },
      )}
    />
  ),
  Home8: createGeneratedRenderer<
    StatisticsSectionProps,
    HomeEightServiceSectionGeneratedProps
  >(HomeEightServiceSectionGenerated, "HomeEightServiceSection"),
  Home15: createGeneratedRenderer<
    StatisticsSectionProps,
    HomeFifteenCounterSectionGeneratedProps
  >(HomeFifteenCounterSectionGenerated, "HomeFifteenCounterSection"),
  Home17: createGeneratedRenderer<
    StatisticsSectionProps,
    HomeSeventeenCounterSectionGeneratedProps
  >(HomeSeventeenCounterSectionGenerated, "HomeSeventeenCounterSection"),
};

export const supportRenderers: Record<
  string,
  GeneratedSectionRenderer<SupportSectionProps>
> = {
  Home8: createGeneratedRenderer<
    SupportSectionProps,
    HomeEightSupportSectionGeneratedProps
  >(HomeEightSupportSectionGenerated, "HomeEightSupportSection"),
  Home15: createGeneratedRenderer<
    SupportSectionProps,
    HomeFifteenSupportSectionGeneratedProps
  >(HomeFifteenSupportSectionGenerated, "HomeFifteenSupportSection"),
};

export const technologyRenderers: Record<
  string,
  GeneratedSectionRenderer<TechnologySectionProps>
> = {
  Home3: createGeneratedRenderer<
    TechnologySectionProps,
    HomeThreeTechnologySectionGeneratedProps
  >(HomeThreeTechnologySectionGenerated, "HomeThreeTechnologySection"),
  Home13: createGeneratedRenderer<
    TechnologySectionProps,
    HomeThirteenTechnologySectionGeneratedProps
  >(HomeThirteenTechnologySectionGenerated, "HomeThirteenTechnologySection"),
};

export const testRenderers: Record<
  string,
  GeneratedSectionRenderer<TestSectionProps>
> = {
  Home12: createGeneratedRenderer<
    TestSectionProps,
    HomeTwelveTestSectionGeneratedProps
  >(HomeTwelveTestSectionGenerated, "HomeTwelveTestSection"),
};

export const videoRenderers: Record<
  string,
  GeneratedSectionRenderer<VideoSectionProps>
> = {
  Home4: createGeneratedRenderer<
    VideoSectionProps,
    HomeFourVideoSectionGeneratedProps
  >(HomeFourVideoSectionGenerated, "HomeFourVideoSection"),
  Home8: createGeneratedRenderer<
    VideoSectionProps,
    HomeEightVideoSectionGeneratedProps
  >(HomeEightVideoSectionGenerated, "HomeEightVideoSection"),
  Home16: createGeneratedRenderer<
    VideoSectionProps,
    HomeSixteenVideoSectionGeneratedProps
  >(HomeSixteenVideoSectionGenerated, "HomeSixteenVideoSection"),
};

export const whyRenderers: Record<
  string,
  GeneratedSectionRenderer<WhySectionProps>
> = {
  Home6: createGeneratedRenderer<
    WhySectionProps,
    HomeSixWhySectionGeneratedProps
  >(HomeSixWhySectionGenerated, "HomeSixWhySection"),
  Home9: createGeneratedRenderer<
    WhySectionProps,
    HomeNineWhyChooseSectionGeneratedProps
  >(HomeNineWhyChooseSectionGenerated, "HomeNineWhyChooseSection"),
  Home18: createGeneratedRenderer<
    WhySectionProps,
    HomeEighteenWhyChooseSectionGeneratedProps
  >(HomeEighteenWhyChooseSectionGenerated, "HomeEighteenWhyChooseSection"),
};

export const workRenderers: Record<
  string,
  GeneratedSectionRenderer<WorkSectionProps>
> = {
  Home2: createGeneratedRenderer<
    WorkSectionProps,
    HomeTwoWorkSectionGeneratedProps
  >(HomeTwoWorkSectionGenerated, "HomeTwoWorkSection"),
  Home7: createGeneratedRenderer<
    WorkSectionProps,
    HomeSevenWorkSectionGeneratedProps
  >(HomeSevenWorkSectionGenerated, "HomeSevenWorkSection"),
  Home10: createGeneratedRenderer<
    WorkSectionProps,
    HomeTenWorkSectionGeneratedProps
  >(HomeTenWorkSectionGenerated, "HomeTenWorkSection"),
  Home11: createGeneratedRenderer<
    WorkSectionProps,
    HomeElevenWorkSectionGeneratedProps
  >(HomeElevenWorkSectionGenerated, "HomeElevenWorkSection"),
  Home12: createGeneratedRenderer<
    WorkSectionProps,
    HomeTwelveWorkSectionGeneratedProps
  >(HomeTwelveWorkSectionGenerated, "HomeTwelveWorkSection"),
  Home14: createGeneratedRenderer<
    WorkSectionProps,
    HomeFourteenTeamSectionGeneratedProps
  >(HomeFourteenTeamSectionGenerated, "HomeFourteenTeamSection"),
  Home18: createGeneratedRenderer<
    WorkSectionProps,
    HomeEighteenWorkSectionGeneratedProps
  >(HomeEighteenWorkSectionGenerated, "HomeEighteenWorkSection"),
};

export const yogaRenderers: Record<
  string,
  GeneratedSectionRenderer<YogaSectionProps>
> = {
  Home17: createGeneratedRenderer<
    YogaSectionProps,
    HomeSeventeenYogaSectionGeneratedProps
  >(HomeSeventeenYogaSectionGenerated, "HomeSeventeenYogaSection"),
};
